document.addEventListener('DOMContentLoaded', function() {
  function overrideSiblingBehaviour() {
    document.querySelectorAll('product-item-siblings').forEach(function(siblingsEl) {
      var productItem = siblingsEl.closest('[data-grid-item]');
      var siblingsInner = siblingsEl.querySelector('[data-sibling-inner]');
      var swatches = siblingsEl.querySelectorAll('tooltip-component');

      // Preload all sibling images on page load
      swatches.forEach(function(swatch) {
        var siblingImage = swatch.getAttribute('data-sibling-image');
        if (siblingImage) {
          var preloadImg = new Image();
          preloadImg.src = siblingImage;
        }
      });

      // Kill the mouseleave reset
      if (siblingsInner) {
        siblingsInner.addEventListener('mouseleave', function(e) {
          e.stopImmediatePropagation();
        }, true);
      }

      swatches.forEach(function(swatch) {
        // Kill mouseenter image change
        swatch.addEventListener('mouseenter', function(e) {
          e.stopImmediatePropagation();
        }, true);

        // Handle click
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          var siblingLink  = swatch.getAttribute('data-sibling-link');
          var siblingImage = swatch.getAttribute('data-sibling-image');
          var siblingColor = swatch.getAttribute('data-tooltip');
          var siblingTitle = swatch.getAttribute('data-sibling-title');

          if (!productItem) return;

          // Update current class
          siblingsEl.querySelectorAll('.sibling__link').forEach(function(el) {
            el.classList.remove('sibling__link--current');
          });
          swatch.querySelector('.sibling__link') &&
          swatch.querySelector('.sibling__link').classList.add('sibling__link--current');

          // Update links
          if (siblingLink) {
            productItem.querySelectorAll('[data-product-link]').forEach(function(link) {
              link.href = siblingLink;
              link.setAttribute('data-product-link', siblingLink);
            });

            // Update the main product image link too
            var productImageLink = productItem.querySelector('.product-item__image a.product-link');
            if (productImageLink) {
              productImageLink.href = siblingLink;
            }
          }

          // Update title — use full sibling title directly from data attribute
          if (siblingTitle) {
            var titleEl = productItem.querySelector('.product-item__title');
            if (titleEl) {
              titleEl.textContent = siblingTitle;
            }
          }

          // Update image — already preloaded so instant
          if (siblingImage) {
            var productImageDefault = productItem.querySelector('[data-product-image-default]');
            var imgSibling = productItem.querySelector('[data-product-image-sibling]');

            if (imgSibling) {
              imgSibling.innerHTML = '';
              var newImg = document.createElement('img');
              newImg.src = siblingImage;
              newImg.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;';
              newImg.classList.add('is-fade', 'is-visible');

              // Make the image itself a clickable link
              var imgLink = document.createElement('a');
              imgLink.href = siblingLink;
              imgLink.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;display:block;';
              imgLink.appendChild(newImg);

              imgSibling.appendChild(imgLink);
              imgSibling.classList.add('is-visible');

              if (productImageDefault) {
                productImageDefault.style.opacity = '0';
              }
            }
          }

        }, true);
      });
    });
  }

  overrideSiblingBehaviour();
});